import { z } from "zod";

export const TRawBookingUnit = z.object({
  name: z.string(),
  titleDisabled: z.boolean().optional(),
  emailRequired: z.boolean().optional(),
  phoneRequired: z.boolean().optional(),
  nameRequired: z.boolean().optional(),
  verificationText: z.string().optional(),
  verifiedBookingText: z.string().optional(),
  verifiedBookingTextDigitalKeys: z.string().optional(),
  dateRange: z
    .object({
      dateTypeStartTime: z.string().nullish(),
      dateTypeEndTime: z.string().nullish(),
      step: z.number().nullish(),
      type: z.string().nullish(),
    })
    .optional(),
  emailVerificationReceivers: z.array(z.string()).optional(),
  calendarColor: z.string().optional(),
  defaultCalendarView: z.string().optional(),
  digitalLocks: z
    .array(z.object({ name: z.string(), lockId: z.string() }))
    .optional(),
  digitalKeyStartBufferTime: z.number().optional(),
  digitalKeyEndBufferTime: z.number().optional(),
  bookingPrivacy: z.string().optional(),
  maxUnlocKeys: z.number().optional(),
  allowOverlappingEvents: z.boolean().optional(),
  minBookingDuration: z.number().optional(),
  maxBookingDuration: z.number().optional(),
  minTimeToStart: z.number().optional(),
  maxTimeToStart: z.number().optional(),
  minTimeBetweenAllEvents: z.number().optional(),
  minTimeBetweenGroupEvents: z.number().optional(),
  minPeriodBeforeCancellation: z.number().optional(),
  bookingGrouping: z.string().optional(),
  disabledParallelBookingUnits: z.array(z.string()).optional(),
  bookingLimitEnabled: z.boolean().optional(),
  standardBookingLimit: z
    .object({
      range: z.string().optional(),
      unit: z.string().optional(),
      count: z.number().optional(),
    })
    .nullish(),
  rolloverEnabled: z.boolean().optional(),
  rolloverMultiplier: z.number().optional(),
  propertyUnitSettings: z.unknown().optional(),
  standardLangCode: z.unknown().optional(),
  customFields: z.object({}).optional(),
  customFieldsOrder: z.array(z.string()).optional(),
});
export type IRawBookingUnit = z.infer<typeof TRawBookingUnit>;
